const Vector = ({ fill = "#19B03A", cls = "" }) => {
  return (
    <svg
      width="12"
      height="7"
      viewBox="0 0 12 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <path
        d="M0.36506 6.3306C0.40524 6.42766 0.473299 6.51062 0.56063 6.569C0.647962 6.62738 0.750642 6.65855 0.855688 6.65857L11.4782 6.65857C11.5833 6.65865 11.6861 6.62755 11.7735 6.56919C11.8609 6.51084 11.9291 6.42786 11.9693 6.33075C12.0095 6.23365 12.0201 6.12679 11.9995 6.02371C11.979 5.92063 11.9284 5.82595 11.854 5.75167L6.54273 0.440404C6.4934 0.391021 6.43482 0.351846 6.37034 0.325117C6.30587 0.298389 6.23675 0.284632 6.16696 0.284632C6.09716 0.284632 6.02804 0.298389 5.96357 0.325117C5.89909 0.351846 5.84051 0.391021 5.79118 0.440404L0.479916 5.75167C0.405661 5.82599 0.355114 5.92066 0.33467 6.02371C0.314225 6.12676 0.324801 6.23356 0.36506 6.3306Z"
        fill={fill}
      />
    </svg>
  );
};
export default Vector;
